import React, { useState } from 'react'
import { useStoreActions, useStoreState } from 'store'
import { formatProductsText } from 'utils/formatTermNames'
import TermsExplainedModal from 'components/filters/TermsExplainedModal'
import SortByFilter from './inputs/SortByFilter'

export default function FiltersSummaryText() {
  const { onClickTracking } = useStoreActions(actions => actions.tracking)
  const [termsExplainedVisible, setTermsExplainedVisible] = useState(false)
  const pointsText = useStoreState(state => {
    let points
    if (state.dimensions.dimensions.mortgageType === 'Purchase') {
      points = state.dimensions.dimensions.purchase.points
    } else {
      points = state.dimensions.dimensions.refinance.points
    }

    if (points === 'Zero') return ' with zero points'
    if (points === 'ZeroToOneInclusive') return ' with 0 - 1 points'
    if (points === 'OneToTwo') return ' with 1.01 - 2 points'
    if (points === 'All') return ' with all points options'
  })

  const propertyTypeText = useStoreState(state => {
    let propertyType
    if (state.dimensions.dimensions.mortgageType === 'Purchase') {
      propertyType = state.dimensions.dimensions.purchase.propertyType
    } else {
      propertyType = state.dimensions.dimensions.refinance.propertyType
    }

    if (propertyType === 'SingleFamily') return 'Single-family home'
    if (propertyType === 'Condo4OrFewerStories') return 'Condominium'
    if (propertyType === 'Townhouse') return 'Townhome'
    if (propertyType === 'MultiFamily2Units') return 'Duplex'
    if (propertyType === 'MultiFamily3Units') return 'Triplex'
    if (propertyType === 'MultiFamily4Units') return 'Quad'
  })

  const productsText = useStoreState(state => {
    return formatProductsText(
      state.dimensions.dimensions.mortgageType === 'Purchase'
        ? state.dimensions.dimensions.purchase.loanTerms
        : state.dimensions.dimensions.refinance.loanTerms
    )
  })

  const isDesktop = useStoreState(state => state.dimensions.isDesktop)

  const openTermsExplained = () => {
    onClickTracking({
      element: {
        type: 'link',
        location: 'rate table',
        position: 'top',
        text: 'Terms Explained',
        name: 'terms explained link',
      },
      outcome: 'MODAL',
    })
    setTermsExplainedVisible(true)
  }

  return (
    <>
      {isDesktop && (
        <div className="gutter display-grid grid-cols-4 gap-6 desk-filters__wrapper">
          <div className="col-span-3">
            <p className="mt-4 mb-0 type-body-two text-slate">
              <strong className="font-circular-bold">Showing results for:</strong> {propertyTypeText}, {productsText}{' '}
              mortgages
              {pointsText}.
              <p className="mb-0">
                The listings that appear on this page are from companies from which this website receives compensation.
              </p>
            </p>
            <button
              type="button"
              onClick={openTermsExplained}
              className="Link Link--standalone bg-transparent px-0 display-inline-flex align-items-center type-body-two mt-2"
            >
              <span>Terms explained</span>
            </button>
            <TermsExplainedModal
              visible={termsExplainedVisible}
              setVisible={setTermsExplainedVisible}
            ></TermsExplainedModal>
          </div>
          <div className="col-span-1">
            <SortByFilter />
          </div>
        </div>
      )}
    </>
  )
}
